'use client';

import type { Locale, StringMap } from 'corgi-types';
import { AppDomainProvider } from 'corgi/common/providers/AppDomainProvider';
import { LocaleProvider } from 'corgi/common/providers/LocaleProvider';
import ThemeProvider from 'corgi/common/providers/ThemeProvider';

import { toCorgiLocale } from '@utils/locale-utils';

export default function Providers({
  locale,
  locales,
  appDomain,
  children,
}: {
  locale: Locale;
  locales: StringMap<string>;
  appDomain: string;
  children: React.ReactNode;
}) {
  return (
    <LocaleProvider locale={toCorgiLocale(locale)} locales={locales}>
      <ThemeProvider>
        <AppDomainProvider appDomain={appDomain}>{children}</AppDomainProvider>
      </ThemeProvider>
    </LocaleProvider>
  );
}
